module.exports = __webpack_public_path__ + "img/sld_mfm_inv_5_t1_b1_dark.cbee51fb.svg";